import { useTranslation } from "react-i18next";
import { usePaginatedQuery } from "../../Hooks/usePaginatedQuery";
import { useState } from "react";
import { PageLayout } from "../../Components/PageLayout";
import DataTable from "../../Components/DataTable/DataTable";
import DebouncedInput from "../../Components/Inputs/DebouncedInput";
import { buildURLWithParams } from "../../Components/Utility/URLUtils";
import { EmployeeCreated, NewEmployee } from "./modals/NewEmployee";
import { TableNavigation } from "../../Components/Tables/Vehicles/TableNavigation";
import EditEmployee from "./modals/EditEmployee";

const DEFAULT_URL = "api/employees/";

const tableColumns = (t) => [
  {
    key: "employeeName",
    header: t("yard-tables.table-columns.name"),
    getValue: (row) => row.full_name,
  },
  {
    key: "title",
    header: t("yard-tables.table-columns.title"),
    getValue: (row) =>
      t(`yard-tables.table-columns.${row.job_title.toLowerCase()}`),
  },
  {
    key: "pin",
    header: "Pin",
    getValue: (row) => row.employee_pin,
  },
];

const EmployeesView = () => {
  const { t } = useTranslation();

  const { state, dispatch } = usePaginatedQuery(DEFAULT_URL);

  const [newEmployee, setNewEmployee] = useState(false);
  const [created, setCreated] = useState(null);

  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const headers = tableColumns(t);

  const [filters, setFilters] = useState({
    name: "",
    title: "",
  });

  const handleFilter = (name, value) => {
    const newFilters = {
      ...filters,
      [name]: value,
    };
    setFilters(newFilters);
    dispatch({
      type: "SET_CURRENT_PAGE",
      page: buildURLWithParams(DEFAULT_URL, newFilters),
      pageNum: 1,
    });
  };

  return (
    <PageLayout title={"Employees"} header={t("employees")}>
      {selectedEmployee && (
        <EditEmployee
          employee={selectedEmployee}
          close={() => setSelectedEmployee(null)}
          onSuccess={(updatedEmployee) => {
            // Update the state with the updated employee
            const updatedData = state.data.map((emp) =>
              emp.id === updatedEmployee.id ? updatedEmployee : emp,
            );
            dispatch({ type: "UPDATE_DATA", payload: updatedData });
            setSelectedEmployee(null);
          }}
        />
      )}
      {created && (
        <EmployeeCreated close={() => setCreated(false)} employee={created} />
      )}
      {newEmployee && (
        <NewEmployee
          close={() => setNewEmployee(false)}
          setCreated={setCreated}
        />
      )}
      <div className="search-filters-cont">
        <div className="search-filters">
          <label>
            {t("yard-tables.table-columns.name")}
            {": "}
            <DebouncedInput
              label={"name"}
              name={"name"}
              state={filters.name}
              setState={handleFilter}
            />
          </label>
          <label>
            {t("yard-tables.table-columns.title")}
            {": "}
            <select
              className="text-input-sm"
              value={filters.title}
              onChange={(e) => handleFilter("title", e.target.value)}
            >
              <option value=""></option>
              <option value="guard">
                {t("yard-tables.table-columns.guard")}
              </option>
              <option value="mechanic">
                {t("yard-tables.table-columns.mechanic")}
              </option>
            </select>
          </label>
          <button
            className="all-btn purple-btn"
            onClick={() => setNewEmployee(true)}
          >
            {t("buttons.new")}
          </button>
        </div>
        <TableNavigation state={state} dispatch={dispatch} />
      </div>
      <DataTable
        columns={headers}
        rows={state.data}
        isLoading={state.isLoading}
        onRowClick={setSelectedEmployee}
      />
    </PageLayout>
  );
};

export default EmployeesView;
